import { render, staticRenderFns } from "./OrganizationExamList.vue?vue&type=template&id=28a978e7&scoped=true&"
import script from "./OrganizationExamList.vue?vue&type=script&lang=js&"
export * from "./OrganizationExamList.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationExamList.vue?vue&type=style&index=0&id=28a978e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a978e7",
  null
  
)

export default component.exports